<template>
  <div class="tv-detail">
    <div class="live-win">
      <video
        id="videoPlayer"
        class="video-class"
        ref="videoRef"
        playsinline
        webkit-playsinline
        controls
      ></video>
    </div>
    <div class="tab-wrapper">
      <van-tabs v-model="tabActive" line-width="0px" @change="tabChange">
        <van-tab
          :title="item.name"
          title-style="font-size: 16px"
          v-for="item in programList"
          :key="item.id"
        ></van-tab>
      </van-tabs>
    </div>
    <div class="content-wrapper">
      <div class="content-left">
        <div
          :class="['left-item', currentDate == item.fullDate && 'left-item-active']"
          v-for="item in dateList"
          :key="item.date"
          @click="handleClickChangeDate(item)"
        >
          <div class="item-name">{{ item.name }}</div>
          <div class="item-date">{{ item.date }}</div>
        </div>
      </div>
      <div class="content-right">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import { queryProgramList } from "@/http/api";
import wxSdk from "@/http/wxApi.js";
import { getMobilsInfo } from "@/utils";

export default {
  name: "TvDetail",
  data() {
    return {
      id: null,
      hls: null,
      tabActive: 0,
      dateList: [],
      currentDate: "",
      programList: [],
    };
  },
  mounted() {
    this.filterData();
    this.getListData();
  },
  methods: {
    getListData() {
      queryProgramList({
        type: 1,
      }).then((res) => {
        console.log(res);
        this.programList = res.data;
        if (this.programList.length) {
          this.programList.forEach((item, index) => {
            if (item.code == this.$route.query.code) {
              this.tabActive = index;
            }
          });
          this.getStream(this.programList[this.tabActive].httpUrl, "auto");
          this.wxShare();
        }
      });
    },
    tabChange() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
        this.$refs.videoRef.pause();
        this.$refs.videoRef.src = null;
      }
      this.getStream(this.programList[this.tabActive].httpUrl, "user");
    },
    getDateDetail(code, menuDate) {
      queryProgramList({
        type: 1,
        radioStationCode: code,
        dataType: 1,
        menuDate,
      }).then((res) => {
        this.programList = res.data;
        if (this.programList.length) {
          this.getStream(this.programList[this.tabActive].httpUrl, "user");
        }
      });
    },
    getNowDate() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();
      month = month < 10 ? `0${month}` : month;
      day = day < 10 ? `0${day}` : day;
      return `${year}-${month}-${day}`;
    },
    filterData() {
      let now = new Date();
      let nowTime = now.getTime();
      let oneDayTime = 24 * 60 * 60 * 1000;
      let dateList = [];
      for (let i = 0; i < 8; i++) {
        //显示周一
        let ShowTime = nowTime + (1 - i) * oneDayTime;
        //初始化日期时间
        let myDate = new Date(ShowTime);
        let year = myDate.getFullYear();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        let str = "星期" + "日一二三四五六".charAt(myDate.getDay());
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;
        if (i == 1) {
          this.currentDate = `${year}-${month}-${day}`;
        }
        dateList.push({
          name: str,
          date: month + "-" + day,
          fullDate: `${year}-${month}-${day}`,
        });
      }
      this.dateList = dateList.reverse();
    },
    handleClickChangeDate(item) {
      if (item.fullDate == this.currentDate) {
        return;
      }
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
        this.$refs.videoRef.pause();
        this.$refs.videoRef.src = null;
      }
      this.currentDate = item.fullDate;
      this.getDateDetail(this.programList[this.tabActive].code, item.fullDate);
    },
    getStream(source, type) {
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(source);
        this.hls.attachMedia(this.$refs.videoRef);
        this.$refs.videoRef.poster = this.programList[this.tabActive].pictureUrl;
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("加载成功");
          // if (status) {
          //   this.$refs.videoRef.play();
          // } else {
          //   this.$refs.videoRef.pause();
          // }
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log("error");
          console.log(event, data);
        });
      } else if (this.$refs.videoRef.canPlayType("application/x-mpegURL")) {
        this.$refs.videoRef.src = source;
        this.$refs.videoRef.poster = this.programList[this.tabActive].pictureUrl;
        if (type == "user") {
          this.$refs.videoRef.play();
        }
        this.$refs.videoRef.addEventListener("loadedmetadata", () => {
          // if (status) {
          //   this.$refs.videoRef.play();
          // } else {
          //   this.$refs.videoRef.pause();
          // }
        });
      }
    },
    wxShare() {
      const _detail = this.programList[this.tabActive];
      wxSdk.getJSSDK({
        title: _detail.name,
        desc: _detail.name,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/tvDetail?code=${_detail.code}`,
        img: _detail.pictureUrl,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tv-detail {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;

  .live-win {
    width: 100%;
    height: calc(100vw * 9 / 16);
    max-height: calc(768px * 9 / 16);
    background: #111;

    .video-class {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tab-wrapper {
    width: 100%;
  }

  .content-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    flex: 1;

    .content-left {
      width: 120px;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      background: #fafafc;
      border-radius: 4px;

      .left-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 10px;
        width: 100%;
        height: 50px;

        .item-name {
          color: #555;
          font-size: 16px;
        }

        .item-date {
          color: #999;
          font-size: 12px;
        }
      }

      .left-item-active {
        background: #f0faff;
        border-radius: 4px;

        .item-name,
        .item-date {
          color: #e73828;
        }
      }
    }

    .content-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      flex: 1;
      height: 100%;
    }
  }
}
</style>
